import { render } from "./brandIntroduction.vue?vue&type=template&id=486ce91c&scoped=true&ts=true"
import script from "./brandIntroduction.vue?vue&type=script&lang=ts"
export * from "./brandIntroduction.vue?vue&type=script&lang=ts"

import "./brandIntroduction.vue?vue&type=style&index=0&id=486ce91c&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486ce91c"]])

export default __exports__